module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Medium.3042dbff.woff2";